<template>
<v-toolbar dark dense flat :class="themeColor" >
    <slot name='buttons-before' ></slot>
    <v-btn @click='$emit("pagetoolbar:homeclicked")' icon>
    <v-icon>home</v-icon>
    </v-btn>
    <slot name='buttons-after' ></slot>
    <v-text-field dark
      prepend-icon="search"
      v-model='searchText'
      v-if='extended' class="white--text" slot="extension" >
    </v-text-field>
    <v-spacer></v-spacer>
    <v-btn v-if='withSearch' @click='extended=true' v-show='extended!==true' icon>
      <v-icon>search</v-icon>
    </v-btn>
    <v-btn @click='searchText="";extended=false' v-show='extended===true' icon>
    <v-icon>close</v-icon>
    </v-btn>
    <slot name='toolbar-right' ></slot>
</v-toolbar>
</template>

<script>
export default {
  name: 'PageToolbar',
  props: {
    value: { type: String, default: '' },
    initialExtended: { type: Boolean, default: false },
    withSearch: { type: Boolean, default: true }
  },
  data () {
    return {
      extended: this.initialExtended,
      searchText: this.value
    }
  },
  mounted () {
    this.extended = this.initialExtended
  },
  watch: {
    searchText () {
      this.$emit('input', this.searchText)
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// PageToolbar.vue?e03652de